import { Alert } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const CustomErrorMessage = ({ message }) => {
  if (!message) return null;

  return (
    <Alert
      severity="error"
      icon={<ErrorOutlineIcon fontSize="small" />}
      sx={{
        width: "100%",
        height: 40,
        py: 0,
        px: 1.5,
        display: "flex",
        alignItems: "center",
        borderRadius: "6px",
        fontSize: "0.875rem",
        "& .MuiAlert-message": {
          display: "flex",
          alignItems: "center",
          padding: 0,
        },
        "& .MuiAlert-icon": {
          display: "flex",
          alignItems: "center",
          padding: 0,
          mr: 1,
        },
      }}
    >
      {message}
    </Alert>
  );
};
